import { z } from 'zod';
/**
 * A fair.
 *
 * The code is not decoration: `next_item_short_code` builds every article's
 * running number from it, so `AMB27` produces `AMB27-0001`. It is therefore
 * shaped like an identifier rather than a label, and frozen once the first
 * article carries it — see the note on the update schema.
 */
export const eventCodeSchema = z
    .string()
    .min(2)
    .max(16)
    .regex(/^[A-Z][A-Z0-9]*$/, 'Das Kürzel besteht aus Großbuchstaben und Ziffern und beginnt mit einem Buchstaben');
export const eventViewSchema = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    location: z.string().nullable(),
    startsOn: z.string().nullable(),
    endsOn: z.string().nullable(),
    isActive: z.boolean(),
    itemCount: z.number().int(),
    /**
     * Whether the code can still be changed.
     *
     * False as soon as one article carries it. Renaming then would leave every
     * existing running number pointing at a code that no longer exists, and the
     * numbers are what people write on a sample.
     */
    codeEditable: z.boolean(),
    /**
     * The published catalogue version this fair captures against, pinned when it
     * was created. Null only for a fair whose version has since been removed.
     */
    schemaVersion: z.number().int().nullable(),
    /**
     * The newest published version, so the portal can offer the lift and say what
     * would change. Equal to `schemaVersion` when the fair is up to date.
     */
    latestSchemaVersion: z.number().int().nullable(),
});
export const eventCreateSchema = z
    .object({
    code: eventCodeSchema,
    name: z.string().min(1).max(200),
    location: z.string().max(200).nullable().default(null),
    startsOn: z.iso.date().nullable().default(null),
    endsOn: z.iso.date().nullable().default(null),
})
    .refine((event) => event.startsOn === null || event.endsOn === null || event.startsOn <= event.endsOn, {
    message: 'Das Ende darf nicht vor dem Anfang liegen',
    path: ['endsOn'],
});
export const eventUpdateSchema = z
    .object({
    /**
     * Only accepted while no article carries the code. The server checks; this
     * is not a client-side courtesy.
     */
    code: eventCodeSchema.optional(),
    name: z.string().min(1).max(200).optional(),
    location: z.string().max(200).nullable().optional(),
    startsOn: z.iso.date().nullable().optional(),
    endsOn: z.iso.date().nullable().optional(),
    isActive: z.boolean().optional(),
    /**
     * Lift the fair onto another published catalogue version.
     *
     * Deliberate and explicit — nothing moves a running fair's form on its own,
     * which is the entire reason the version is pinned in the first place.
     */
    schemaVersion: z.number().int().positive().optional(),
})
    .refine((event) => event.startsOn === undefined ||
    event.endsOn === undefined ||
    event.startsOn === null ||
    event.endsOn === null ||
    event.startsOn <= event.endsOn, { message: 'Das Ende darf nicht vor dem Anfang liegen', path: ['endsOn'] });
//# sourceMappingURL=event-api.js.map